package search.global

import search.searchFilterStores.ActiveFieldValuesStore

class ActiveSearchFieldValuesStore : ActiveFieldValuesStore()
